import {ActionType, SortDirection} from "../../../../common/enums/enums";

export class AssignBoardFilters {
    buildingGuid?: string;
    sortDirection = SortDirection.DESC;
    jobType?: ActionType;
}